import FormattedMessage from 'I18n/components/FormattedMessage';
import { MatchRateCard } from './MatchRateCard';
import { useEnrichableObjectTypes } from '../../EnrichableObjectTypesProvider/EnrichableObjectTypeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const MatchRateCardEnrichable = ({
  count,
  isContactEnrichment,
  isLoading
}) => {
  const {
    companyLabel,
    companyLabelLowercase,
    companyLabelPlural,
    contactLabel,
    contactLabelLowercase,
    contactLabelPlural
  } = useEnrichableObjectTypes();
  if (isContactEnrichment) {
    return /*#__PURE__*/_jsx(MatchRateCard, {
      count: count,
      isLoading: isLoading,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.matchRate.contacts.enrichableTooltip",
        options: {
          contact: contactLabelLowercase,
          contacts: contactLabelPlural
        }
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dataTest.matchRate.contacts.enrichable",
        options: {
          objectType: count === 1 ? contactLabel : contactLabelPlural
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(MatchRateCard, {
    count: count,
    isLoading: isLoading,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.companies.enrichableTooltip",
      options: {
        company: companyLabelLowercase,
        companies: companyLabelPlural
      }
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dataTest.matchRate.companies.enrichable",
      options: {
        objectType: count === 1 ? companyLabel : companyLabelPlural
      }
    })
  });
};